import React, { Component } from "react";
import MainBodyContainer from "./body/MainBodyContainer";
import { inject, observer } from "mobx-react";
import { fn_orderList } from "function/FnBodyLayer";

@inject("rootStore")
@observer
class MainOrderListContainer extends Component {

    constructor(props) {
        super(props);
    }

    fnReload(rootStore, targetComponent) {
        fn_orderList(rootStore)
    }

    render() {
        const { rootStore } = this.props;
        return (
            <MainBodyContainer rootStore={rootStore} />
        );
    }
}

export default MainOrderListContainer;